import React from "react";
import { FormGroup, ModalBody, ModalHeader, Input, Label, Button, Form, InputGroup, InputGroupAddon, InputGroupText} from "reactstrap";
import SimpleReactValidator from "simple-react-validator";
import { changePassword } from "../../services/authService";
import { notifyError, notifySuccess } from "../../utils/utils";

class ChangePassword extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            oldPass: "",
            newPass: "",
            confirmPass: "",
            visibility: {
                old: false,
                new: false,
                confirm:false
            },
            alertModel: false,
            alertMessage: "",
        };

        this.validator = new SimpleReactValidator({
            locale: 'en', messages:{}, autoForceUpdate: this,
            validators: {
                confirmPass: {  // name the rule
                    message: 'New password and Confirm password must be same', 
                    rule: (val, params, validator) => {
                      return val[0] === val[1] ?  true : false
                    },
                    required: true 
                  }
            }
        });

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        if(!this.validator.allValid()){
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }
        const data = { 
            oldPass: this.state.oldPass,
            newPass: this.state.newPass
        }
      
        changePassword(data)
        .then(data  => {
           if(data.status) {
            notifySuccess(data.message);
            setTimeout(() => {
                this.props.toggle();
            }, 1000);
        } else {
            notifyError(data.message);
        }
        }); 
    }


    

    render() {
        this.validator.purgeFields();

        const { visibility } = this.state; 

        return(

            <React.Fragment>
                        <ModalHeader toggle={() => this.props.toggle()}> 
                            Change Password
                        </ModalHeader>
                        <ModalBody>                       
                            <Form onSubmit={this.handleSubmit} autoComplete="off">
                                <FormGroup>
                                    <Label>Old Password</Label>
                                    <InputGroup>                                
                                    <Input
                                        type= {visibility.old ? "text" : "password"}
                                        name="oldPass"
                                        value={this.state.oldPass}
                                        onChange={e => {
                                            this.setState({
                                                oldPass: e.target.value
                                            });
                                        }}
                                        />
                                         <InputGroupText onClick={e => {
                                                this.setState({
                                                    visibility: { 
                                                        ...visibility,
                                                        old: !visibility.old
                                                    }
                                                })
                                            }}> <i className="fas fa-eye"></i></InputGroupText>
                                    </InputGroup>
                                <span className="text-danger">
                                    {this.validator.message('Old Password',this.state.oldPass, 'required|min:5|max:10')}
                                </span>
                                </FormGroup>

                                <FormGroup>
                                    <Label>New Password</Label>
                                    <InputGroup>
                                    <Input
                                        type={visibility.new ? "text" : "password"}
                                        name="newPass"
                                        value={this.state.newPass}
                                        onChange={e => {
                                            this.setState({
                                                newPass: e.target.value
                                            });
                                        }}
                                        />
                                         <InputGroupAddon addonType="append">
                                            <InputGroupText onClick={e => {
                                                this.setState({
                                                    visibility: { 
                                                        ...visibility,
                                                        new: !visibility.new
                                                    }
                                                })
                                            }}> <i className="fas fa-eye"></i></InputGroupText>
                                        </InputGroupAddon>
                                    </InputGroup>
                                <span className="text-danger">
                                    {this.validator.message('New Password',this.state.newPass, 'required|min:5|max:10')}
                                </span>
                                </FormGroup>

                                <FormGroup>
                                    <Label>Confirm New Password</Label>

                                    <InputGroup>
                                    <Input
                                        type={visibility.confirm ? "text" : "password"}
                                        name="confirmPass"
                                        value={this.state.confirmPass}
                                        onChange={e => {
                                            this.setState({
                                                confirmPass: e.target.value
                                            });
                                        }}
                                	/>
			    
                                       <InputGroupText 
									   	onClick={e => {
                                                this.setState({
                                                    visibility: { 
                                                        ...visibility,
                                                        confirm: !visibility.confirm
                                                    }
                                                })
                                            }}> <i className="fas fa-eye"></i>
										</InputGroupText>
                                    </InputGroup>
                                    
                                    
                                    <span className="text-danger">
                                        {this.validator.message('New Password',[this.state.newPass, this.state.confirmPass], 'confirmPass')}
                                    </span>
                                </FormGroup>

                                <FormGroup className="pull-right">
                                        <Button color="success" type="submit">Submit</Button>
                                </FormGroup>
                            </Form>
                        </ModalBody>
            </React.Fragment>
        )
    }
}

export default ChangePassword;